import { render, staticRenderFns } from "./BuyBoxOfferNew.vue?vue&type=template&id=14bead1b&scoped=true"
import script from "./BuyBoxOfferNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxOfferNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxOfferNew.vue?vue&type=style&index=0&id=14bead1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bead1b",
  null
  
)

export default component.exports